export default {
  "cn": {
    "survey": {
      "title": "满意度调查",
      "score": {
        "q": "你向朋友或同事推荐 Bye!消除 的可能性有多大？",
        "tips": {
          "no": "不愿意",
          "yes": "非常愿意"
        }
      },
      "reason": {
        "highScore": {
          "q": "当你向朋友或同事推荐 Bye!消除 时，你准备如何告诉 TA？"
        },
        "lowScore": {
          "q": "你认为 Bye!消除 最应该改进的三个问题是什么？"
        }
      },
      "advice": {
        "improvement": "关于去除照片或视频上不想要的内容，你还有什么想说的吗？",
        "contact": "我们想进一步与你取得联系，如果愿意，请留下你的联系方式。"
      },
      "placeholder": "点击此处以输入",
      "contactWay": "QQ/微信号/手机号",
      "toastTips": "感谢参与",
      "next": "下一步",
      "done": "提交"
    }
  },
  "en": {
    "survey": {
      "title": "Satisfaction survey",
      "score": {
        "q": "How likely is it that you would recommend Remoooove to a friend or colleague?",
        "tips": {
          "no": "Not at all likely",
          "yes": "Extremely likely"
        }
      },
      "reason": {
        "highScore": {
          "q": "How would you describe Remoooove to a friend or colleague?"
        },
        "lowScore": {
          "q": "What are the three biggest things you dislike about Remoooove?"
        }
      },
      "advice": {
        "improvement": "Do you have anything else to say about remove unwanted part from photo or video?",
        "contact": "We would like to contact you further, if you wish, please leave your contact information."
      },
      "placeholder": "Input here",
      "contactWay": "E-mail / Facebook",
      "toastTips": "Thank you for participating",
      "next": "Next",
      "done": "Submit"
    }
  },
  "th": {
    "survey": {
      "title": "แบบสำรวจความพึงพอใจ",
      "score": {
        "q": "คุณมีแนวโน้มจะแนะนำ Remoooove ให้เพื่อนหรือเพื่อนร่วมงานมากน้อยแค่ไหน",
        "tips": {
          "no": "ไม่เต็มใจ",
          "yes": "เต็มใจมาก"
        }
      },
      "reason": {
        "highScore": {
          "q": "เมื่อคุณแนะนำ Remoooove ให้เพื่อนหรือเพื่อนร่วมงาน คุณจะบอกเขาอย่างไร"
        },
        "lowScore": {
          "q": "คุณคิดว่าปัญหาสามประการที่ควรปรับปรุงมากที่สุดของ Remoooove คืออะไร"
        }
      },
      "advice": {
        "improvement": "คุณมีอะไรจะพูดอีกหรือไม่เกี่ยวกับการกำจัดเนื้อหาที่ไม่ต้องการออกจากรูปภาพหรือวิดีโอ",
        "contact": "เราต้องการติดต่อคุณต่อไป โปรดทิ้งข้อมูลการติดต่อของคุณไว้หากยินยอม"
      },
      "placeholder": "คลิกที่นี่เพื่อป้อน",
      "contactWay": "อีเมล/Facebook",
      "toastTips": "ขอขอบคุณที่เข้าร่วม",
      "next": "ขั้นต่อไป",
      "done": "ส่ง"
    }
  },
  "vi": {
        "survey": {
      "title": "Satisfaction survey",
      "score": {
        "q": "How likely is it that you would recommend Remoooove to a friend or colleague?",
        "tips": {
          "no": "Not at all likely",
          "yes": "Extremely likely"
        }
      },
      "reason": {
        "highScore": {
          "q": "How would you describe Remoooove to a friend or colleague?"
        },
        "lowScore": {
          "q": "What are the three biggest things you dislike about Remoooove?"
        }
      },
      "advice": {
        "improvement": "Do you have anything else to say about remove unwanted part from photo or video?",
        "contact": "We would like to contact you further, if you wish, please leave your contact information."
      },
      "placeholder": "Input here",
      "contactWay": "E-mail / Facebook",
      "toastTips": "Thank you for participating",
      "next": "Next",
      "done": "Submit"
    }
  },
  "ja": {
    "survey": {
      "title": "満足度調査",
      "score": {
        "q": "友人や同僚に「Remoooove」をすすめしたいですか？",
        "tips": {
          "no": "すすめしたくない",
          "yes": "すすめしたい"
        }
      },
      "reason": {
        "highScore": {
          "q": "友人や同僚に「Remoooove」をおすすめる場合、どう紹介しますか？"
        },
        "lowScore": {
          "q": "「Remoooove」に最も改善すべきと思う3つの問題はありますか？"
        }
      },
      "advice": {
        "improvement": "写真や動画から不要な内容を消去することについて、他に何かご意見はありますか？",
        "contact": "さらにこちらから連絡する場合がありますので、よろしければ連絡先をご記入ください。"
      },
      "placeholder": "こちらにタップして入力",
      "contactWay": "メールアドレス/Facebook",
      "toastTips": "ご参加ありがとうございました",
      "next": "次へ",
      "done": "提出"
    }
  },
  "ko": {
    "survey": {
      "title": "Satisfaction survey",
      "score": {
        "q": "How likely is it that you would recommend GLIZA to a friend or colleague?",
        "tips": {
          "no": "Not at all likely",
          "yes": "Extremely likely"
        }
      },
      "reason": {
        "highScore": {
          "q": "How would you describe GLIZA to a friend or colleague?"
        },
        "lowScore": {
          "q": "What are the three biggest things you dislike about GLIZA?"
        }
      },
      "advice": {
        "improvement": "Do you have anything else to say about remove unwanted part from photo or video?",
        "contact": "We would like to contact you further, if you wish, please leave your contact information."
      },
      "placeholder": "Input here",
      "contactWay": "E-mail / Facebook",
      "toastTips": "Thank you for participating",
      "next": "Next",
      "done": "Submit"
    }
  },
  "id": {
    "survey": {
      "title": "Satisfaction survey",
      "score": {
        "q": "How likely is it that you would recommend GLIZA to a friend or colleague?",
        "tips": {
          "no": "Not at all likely",
          "yes": "Extremely likely"
        }
      },
      "reason": {
        "highScore": {
          "q": "How would you describe GLIZA to a friend or colleague?"
        },
        "lowScore": {
          "q": "What are the three biggest things you dislike about GLIZA?"
        }
      },
      "advice": {
        "improvement": "Do you have anything else to say about remove unwanted part from photo or video?",
        "contact": "We would like to contact you further, if you wish, please leave your contact information."
      },
      "placeholder": "Input here",
      "contactWay": "E-mail / Facebook",
      "toastTips": "Thank you for participating",
      "next": "Next",
      "done": "Submit"
    }
  },
  "es": {
    "survey": {
      "title": "Satisfaction survey",
      "score": {
        "q": "How likely is it that you would recommend GLIZA to a friend or colleague?",
        "tips": {
          "no": "Not at all likely",
          "yes": "Extremely likely"
        }
      },
      "reason": {
        "highScore": {
          "q": "How would you describe GLIZA to a friend or colleague?"
        },
        "lowScore": {
          "q": "What are the three biggest things you dislike about GLIZA?"
        }
      },
      "advice": {
        "improvement": "Do you have anything else to say about remove unwanted part from photo or video?",
        "contact": "We would like to contact you further, if you wish, please leave your contact information."
      },
      "placeholder": "Input here",
      "contactWay": "E-mail / Facebook",
      "toastTips": "Thank you for participating",
      "next": "Next",
      "done": "Submit"
    }
  },
  "pt": {
    "survey": {
      "title": "Satisfaction survey",
      "score": {
        "q": "How likely is it that you would recommend GLIZA to a friend or colleague?",
        "tips": {
          "no": "Not at all likely",
          "yes": "Extremely likely"
        }
      },
      "reason": {
        "highScore": {
          "q": "How would you describe GLIZA to a friend or colleague?"
        },
        "lowScore": {
          "q": "What are the three biggest things you dislike about GLIZA?"
        }
      },
      "advice": {
        "improvement": "Do you have anything else to say about remove unwanted part from photo or video?",
        "contact": "We would like to contact you further, if you wish, please leave your contact information."
      },
      "placeholder": "Input here",
      "contactWay": "E-mail / Facebook",
      "toastTips": "Thank you for participating",
      "next": "Next",
      "done": "Submit"
    }
  },
  "tw": {
    "survey": {
      "title": "滿意度調查",
      "score": {
        "q": "你向朋友或同事推薦 Bye!消除 的可能性有多大？",
        "tips": {
          "no": "不願意",
          "yes": "非常願意"
        }
      },
      "reason": {
        "highScore": {
          "q": "當你向朋友或同事推薦 Bye!消除 時，你準備如何告訴 TA？"
        },
        "lowScore": {
          "q": "你認為 Bye!消除 最應該改進的三個問題是什麼？"
        }
      },
      "advice": {
        "improvement": "關於去除照片或視頻上不想要的內容，你還有什麼想說的嗎？",
        "contact": "我們想進一步與你取得聯繫，如果願意，請留下你的聯繫方式。"
      },
      "placeholder": "點擊此處以輸入",
      "contactWay": "Instagram/WeChat/Email",
      "toastTips": "感謝參與",
      "next": "下一步",
      "done": "提交"
    }
  }
}
